<template>
  <component
    :is="tag"
    v-if="shouldRender"
    :class="classes"
  >
    <slot />
  </component>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AuthWrapper',
    props: {
      tag: {
        type: String,
        default: 'section',
      },
      classes: {
        type: String,
        default: ''
      },
      showLoggedInOnly: {
        type: Boolean,
        default: false,
      },
      showNotLoggedInOnly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        shouldRender: false
      }
    },
    computed: {
      ...mapGetters('auth', ['isAuthenticated']),
    },
    mounted() {
      this.shouldRender = this.calculateRender()
    },
    methods: {
      calculateRender() {
        if (this.showLoggedInOnly) {
          return this.isAuthenticated
        }

        if (this.showNotLoggedInOnly) {
          return !this.isAuthenticated
        }

        return true
      }
    }
  }
</script>
